/* eslint-disable */
import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import translation function for language translation
import { useTranslation } from "react-i18next";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import batch options from json
import batchLotOption from "data/Prod/Batch.json";

const ActivityFilter = () => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation();

  const {
    setReloadActivityList,
    setSearchActivityName,
    setsearchActivityCode,
    setSearchActivityCourse,
    setSearchActivityLot,
    setSearchActivityMaterialKits,
    setSearchActivityType,
    setSearchActivityEducators,
  } = useContext(GlobalProvider);

  // Returns true when a react-select value has at least one entry selected
  const isSelected = (val) => (Array.isArray(val) ? val.length > 0 : !!val);

  const selectedTileStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({ ...base, backgroundColor: "transparent", borderColor: "transparent", boxShadow: "none" }),
  };
  const defaultTileStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  // ── Dropdown option lists ──────────────────────────────────────────────────
  const [activityNameOptions, setActivityNameOptions] = useState([]);
  const [courseList, setCourseList] = useState([]);
  const [educatorList, setEducatorList] = useState([]);
  const [materialKitList, setMaterialKitList] = useState([]);

  // ── Selected values ────────────────────────────────────────────────────────
  const [activityNameValue, setActivityNameValue] = useState(null);
  const [activityCodeInput, setActivityCodeInput] = useState("");
  const [activityTypeValue, setActivityTypeValue] = useState(null);
  const [courseValue, setCourseValue] = useState(null);
  const [selectedCourseIds, setSelectedCourseIds] = useState([]);
  const [educatorValue, setEducatorValue] = useState(null);
  const [selectedEducators, setSelectedEducators] = useState([]);
  const [materialKitValue, setMaterialKitValue] = useState(null);
  const [selectedMaterialKits, setSelectedMaterialKits] = useState([]);
  const [lotValue, setLotValue] = useState(null);
  const [selectedLots, setSelectedLots] = useState([]);

  // ── API fetches ────────────────────────────────────────────────────────────
  const getActivityNameOptions = async () => {
    try {
      const requestUrl =
        url.API_BASEURL + url.API_GET_ALL_ACTIVITY + `?token=${token}&isselect=true`;
      const response = await getData(requestUrl);
      if (response.status) {
        // Build name options: unique names as { label, value }
        const seen = new Set();
        const opts = [];
        response.data.forEach(({ label }) => {
          // label from isselect = "code : name", extract the name part
          const namePart = label.includes(" : ") ? label.split(" : ").slice(1).join(" : ").trim() : label;
          if (namePart && !seen.has(namePart)) {
            seen.add(namePart);
            opts.push({ label: namePart, value: namePart });
          }
        });
        setActivityNameOptions(opts);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const getAllCourseList = async () => {
    try {
      const requestUrl =
        url.API_BASEURL + url.API_GET_ALL_COURSE + `?token=${token}&isselect=true`;
      const response = await getData(requestUrl);
      if (response.status) setCourseList(response.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getAllEducatorList = async () => {
    try {
      const requestUrl =
        url.API_BASEURL + url.API_GET_ALL_USER + `?token=${token}&isselect=true&slug=educator&limit=0`;
      const response = await getData(requestUrl);
      if (response.status) setEducatorList(response.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getAllMaterialKitList = async () => {
    try {
      const requestUrl =
        url.API_BASEURL + url.API_GET_ALL_MATERIAL_KIT + `?token=${token}&isselect=true`;
      const response = await getData(requestUrl);
      if (response.status) setMaterialKitList(response.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  // ── Handlers ───────────────────────────────────────────────────────────────
  const searchHandler = () => {
    setSearchActivityName(activityNameValue?.value || "");
    setsearchActivityCode(activityCodeInput.trim());
    setSearchActivityCourse(selectedCourseIds);
    setSearchActivityLot(selectedLots);
    setSearchActivityMaterialKits(selectedMaterialKits);
    setSearchActivityType(activityTypeValue ? activityTypeValue.map((v) => v.value) : []);
    setSearchActivityEducators(selectedEducators);
  };

  const resetHandler = () => {
    setActivityNameValue(null);
    setActivityCodeInput("");
    setActivityTypeValue(null);
    setCourseValue(null);
    setSelectedCourseIds([]);
    setEducatorValue(null);
    setSelectedEducators([]);
    setMaterialKitValue(null);
    setSelectedMaterialKits([]);
    setLotValue(null);
    setSelectedLots([]);
    setSearchActivityName("");
    setsearchActivityCode("");
    setSearchActivityCourse([]);
    setSearchActivityLot([]);
    setSearchActivityMaterialKits([]);
    setSearchActivityType([]);
    setSearchActivityEducators([]);
    setReloadActivityList(true);
  };

  // ── Init ───────────────────────────────────────────────────────────────────
  useEffect(() => {
    getActivityNameOptions();
    getAllCourseList();
    getAllEducatorList();
    getAllMaterialKitList();
  }, []);

  return (
    <div className="collapse mt-3" id="filterCollapse">
      <div className="p-3 bg-gray-200">
        <form onSubmit={(e) => e.preventDefault()}>

          {/* ===== BLOCK 1: Search Activity ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>manage_search</span>
              {t("Search Activity")}
            </p>
            <div className="row g-3">

              {/* Name */}
              <div className="col-lg-4">
                <div className={`border rounded p-2 h-100 ${isSelected(activityNameValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Name")}</label>
                  <CreatableSelect
                    isClearable
                    options={activityNameOptions}
                    placeholder={t("Search by name...")}
                    value={activityNameValue}
                    onChange={(val) => setActivityNameValue(val)}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(activityNameValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* Code */}
              <div className="col-lg-4">
                <div className={`border rounded p-2 h-100 ${activityCodeInput.trim() ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Code")}</label>
                  <input
                    type="text"
                    className="form-control border-0 bg-transparent px-0"
                    placeholder={t("Search by code...")}
                    value={activityCodeInput}
                    onChange={(e) => setActivityCodeInput(e.target.value)}
                  />
                </div>
              </div>

              {/* Activity Type */}
              <div className="col-lg-4">
                <div className={`border rounded p-2 h-100 ${isSelected(activityTypeValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Activity Type")}</label>
                  <CreatableSelect
                    isMulti
                    placeholder={t("Type or select...")}
                    value={activityTypeValue}
                    onChange={(val) => setActivityTypeValue(val)}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(activityTypeValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 1 ===== */}

          {/* ===== BLOCK 2: Filter by Relations ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>filter_alt</span>
              {t("Filter by Relations")}
            </p>
            <div className="row g-3">

              {/* Course */}
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(courseValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Course")}</label>
                  <Select
                    isMulti
                    options={courseList}
                    placeholder={t("Select course")}
                    value={courseValue}
                    onChange={(val) => {
                      setCourseValue(val);
                      setSelectedCourseIds(val.map((item) => item.value));
                    }}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(courseValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* Educators */}
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(educatorValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Educators")}</label>
                  <Select
                    isMulti
                    options={educatorList}
                    placeholder={t("Select educators")}
                    value={educatorValue}
                    onChange={(val) => {
                      setEducatorValue(val);
                      setSelectedEducators(val.map((item) => item.value));
                    }}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(educatorValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* Material Kits */}
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(materialKitValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Material Kits")}</label>
                  <Select
                    isMulti
                    options={materialKitList}
                    placeholder={t("Select material kits")}
                    value={materialKitValue}
                    onChange={(val) => {
                      setMaterialKitValue(val);
                      setSelectedMaterialKits(val.map((item) => item.value));
                    }}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(materialKitValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* Lot / Batch */}
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(lotValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Batch / Lot")}</label>
                  <Select
                    isMulti
                    options={batchLotOption}
                    placeholder={t("Select lot")}
                    value={lotValue}
                    onChange={(val) => {
                      setLotValue(val);
                      setSelectedLots(val.map((item) => item.value));
                    }}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(lotValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 2 ===== */}

          {/* ===== Actions ===== */}
          <div className="d-flex gap-3 align-items-center justify-content-end">
            <Link
              to="#"
              className="d-flex gap-1 align-items-center text-secondary"
              onClick={resetHandler}
            >
              <span className="material-symbols-outlined icon-md">sync</span>
              <span className="fw-medium">{t("Reset")}</span>
            </Link>
            <button
              type="submit"
              className="btn btn-primary px-4 d-flex align-items-center gap-2"
              onClick={searchHandler}
            >
              <span className="material-symbols-outlined align-middle" style={{ fontSize: "18px" }}>search</span>
              {t("Filter")}
            </button>
          </div>
          {/* ===== End Actions ===== */}

        </form>
      </div>
    </div>
  );
};

export default ActivityFilter;
